export interface DecedentInfoState {
  firstName: string;
  middleName: string;
  lastName: string;
  decedentId_private: string;
  zipCode: string;
  dateOfDeath: string;
  dateOfBirth: string;
  decedentPoid: string;
  isDeathVerified: boolean;
  deathStatusSetBy: string;
  multiplePoids: boolean;
  isReviewModalVisible: boolean;
  decedentIdExceededAttempts: boolean;
  inheritanceWaiverState: string;
  clearDateOfDeath?: string;
}
